(function () {
    'use strict';

    /**
     *
     *
     */
    angular
        .module('hardSoftRule')
        .service('HardSoftRuleService', HardSoftRuleService);

    function HardSoftRuleService(RemoteService,HardSoftRuleRequestFactory) {
        var self = this;

         var model={
        		 searchCriteria: HardSoftRuleRequestFactory.getRegSearchRequest(),
        		 regList:[]
        };


       self.setSearchCriteria = function (searchCriteria,isHard) {
           model.searchCriteria = HardSoftRuleRequestFactory.getSearchRequest(searchCriteria,isHard);
       };


       self.getRegulations = function(successFn, errorFn){
           RemoteService.searchRegulations(model.searchCriteria).then(
               function (response) {
                   if(response.success){
                       model.regList = response.list
                       successFn(model.regList);
                   }
               },
               function (error) {
                   errorFn(error.msg[0]);
               }
           );
       };

       self.saveSelectedReg = function (reg, successFn, errorFn) {
           var saveReq = HardSoftRuleRequestFactory.getRegForSave(reg);
           RemoteService.saveRegulations(saveReq).then(
               function (response) {
                   successFn(response);
               },
               function (error) {
                   errorFn(error.msg[0]);
               }
           );
       };


       self.getRuleForEdit = function (regulation) {
           var editor = HardSoftRuleRequestFactory.getRuleForEdit();
           editor.durationForRoster = regulation.durationForRoster;
           editor.companyValue1 = regulation.companyValue1;
           editor.status = regulation.statusDisplayValue==="Inactive"?true:false;
           editor.regulationId = regulation.regulationId;
           editor.version = regulation.version;
           editor.desirability = regulation.desirability*10;
           editor.description = regulation.description;

           var list = []
           angular.forEach(regulation.acmiTypes,function (type) {
                     var item = {};
                     item.acmiCode = type;
                     item.selected = true;
                     list.push(item);
                   });
           editor.acmiCodes = list;
           editor.ruleClassification = {"ruleClassificationCode" : regulation.ruleClassificationCode};
           editor.ruleClassificationCode = regulation.ruleClassificationCode;
           editor.onlyACMI = regulation.onlyAcmi === 'Y' ? true : false;

           return editor;
       };

       self.getEmptyRule = function () {
           return HardSoftRuleRequestFactory.getRuleForEdit();
       }
    }
})();
